import React from 'react'
import moment from 'moment'
import Images from 'assets/images'
import './supportchatbubble.scss'
import useModal from 'hooks/useModal';
import Spacer from 'components/Spacer/Spacer';

const SENDER_TYPE = {
    provider: "PracticeUser",
    user: "Account",
};

const getImagesView = (attachments, onClickImage) => {
    if (attachments?.length) {
      return (
        <div className="flex flex-wrap">
          {attachments?.map((attachment, index) => {
            const isPDF = attachment?.file_name?.includes(".pdf") || attachment?.file_type?.includes("pdf");
            const isDoc = attachment?.file_name?.includes(".doc") || attachment?.file_type?.includes("doc");
            if(isPDF || isDoc){
              return null;
            }
            return (
              <div
                key={index}
                className="relative flex items-center justify-center w-32 h-32 mb-4 mr-4 overflow-hidden bg-black min-w-32 min-h-32 rounded-3xl"
              >
                <img
                  onClick={() => onClickImage(attachment?.url)}
                  className={`object-contain cursor-pointer absolute ${
                    isPDF ? "w-3/4 h-3/4" : isDoc ? "w-3/4 h-3/4" : "w-full h-full"
                  }`}
                  key={index}
                  src={isPDF ? Images.pdfIcon : isDoc ? Images.docIcon : attachment?.url}
                  alt="img"
                />
              </div>
            );
          })}
        </div>
      );
    } else {
      return null;
    }
};

function SupportChatBubble({ conversation, showDateBanner, avatars }) {

    const { setShowModal } = useModal();

    function onClickImage(imageUrl) {
        const isPDF = imageUrl?.includes(".pdf") || imageUrl?.includes(".PDF");
        const isDoc = imageUrl?.includes(".doc") || imageUrl?.includes(".DOC");
        
        if (!isPDF && !isDoc){
            setShowModal({
              state: true,
              children: (_, onClose) => (
                <div className="flex items-center justify-center w-full h-screen bg-black bg-opacity-20">
                  <div className="relative h-full wrapper">
                    <img
                      src={imageUrl}
                      className="absolute object-contain w-full h-full"
                      alt="img"
                    />
                    <div
                      className="absolute flex items-center justify-center w-16 h-16 bg-opacity-50 rounded-full shadow-2xl cursor-pointer bg-alternativeWhite top-4 right-4"
                      onClick={onClose}
                    >
                      <img src={Images.closeIcon} alt="close" className="w-8 h-8" />
                    </div>
                  </div>
                </div>
              ),
            });
        }
    }
    const dateBanner = () => {
        if(moment(conversation?.created_at).format("MMMM DD, YYYY") === 'Invalid date'){
            return null;
        }
        return(
        <p className="w-full text-xl font-medium text-center pt-7">
            {moment(conversation?.created_at).format("MMMM DD, YYYY")}
        </p>)
    };

    const hasAttachments = (conversation?.attachments?.length > 0 && conversation?.attachments?.some((attachment) => attachment?.file_name?.includes(".pdf") || attachment?.file_type?.includes("pdf"))) || (conversation?.attachments?.length > 0 && conversation?.attachments?.some((attachment) => attachment?.file_name?.includes(".doc") || attachment?.file_type?.includes("doc")));

    if(conversation?.sender_type === SENDER_TYPE.provider){
        let providerAvatar = avatars?.practice_users?.find((avatar) => avatar?.sender_id === conversation?.sender_id);
  return (
    <div className="flex flex-col">
        {showDateBanner ? dateBanner() : null}
        <div className="flex items-end mt-8 mb-4">
        <img
            src={providerAvatar?.gravatar_url}
            alt="dp"
            className="w-16 h-16 rounded-2xl object-cover flex-shrink-0"
        />
        <div className="w-full px-4 py-4 ml-3 break-words bg-blue rounded-xl min-w-1/10 md:w-10/12">
            {getImagesView(
                conversation?.attachments,
                onClickImage
            )}
            <p
            className="bubble_content_provider text-white text-2xl font-medium"
            dangerouslySetInnerHTML={{
                __html: conversation?.message,
            }}
            />
            <Spacer height={10} />
            {hasAttachments && <p className="text-2xl text-white font-medium">Attachments:</p>}
            {conversation?.attachments?.map((attachment, index) => {
              const isPDF = attachment?.file_name?.includes(".pdf") || attachment?.file_type?.includes("pdf");
              const isDoc = attachment?.file_name?.includes(".doc") || attachment?.file_type?.includes("doc");
              if(isPDF || isDoc){
              return (
                <a href={attachment?.url} target="_blank" className='text-white underline text-2xl font-medium' key={index} rel="noreferrer">
                    {attachment?.file_name}
                  </a>
                )
              }
              return null;
            })}
        </div>
        </div>
            <div className="flex items-center ml-20">
        <img
            src={Images.clockIcon}
            alt="time"
            className="object-contain w-4 h-4"
        />
        <p className="ml-2 text-base font-medium">
            {moment(conversation?.created_at).format("LT") === 'Invalid date' ? moment(new Date()).format("LT") : moment(conversation?.created_at).format("LT")}
        </p>
        </div>
    </div>
  )
}else{
    return (
        <div className="flex flex-col items-end">
            {showDateBanner ? dateBanner() : null}
            <div className="flex items-end mt-8 mb-4 justify-end"> 
                <div className="w-full px-4 py-4 ml-3 break-words bg-whiteTwo rounded-xl min-w-1/10 md:w-10/12">
                  {getImagesView(
                      conversation?.attachments,
                      onClickImage
                  )}
                  
                  <p
                    className="bubble_content_user text-themeBlack text-2xl font-medium"
                    dangerouslySetInnerHTML={{
                        __html: conversation?.message,
                    }}
                  />
                  <Spacer height={10} />
                  {hasAttachments && <p className="text-2xl font-medium">Attachments:</p>}
                  {conversation?.attachments?.map((attachment, index) => {
                    const isPDF = attachment?.file_name?.includes(".pdf") || attachment?.file_type?.includes("pdf");
                    const isDoc = attachment?.file_name?.includes(".doc") || attachment?.file_type?.includes("doc");
                    if(isPDF || isDoc){
                    return (
                      <a href={attachment?.url} target="_blank" className='text-indigo underline text-2xl font-medium' key={index} rel="noreferrer">
                          {attachment?.file_name}
                        </a>
                      )
                    }
                    return null;
                  })}
                </div>
                <img
                    src={avatars?.patients[0]?.gravatar_url}
                    alt="dp"
                    className="w-16 h-16 rounded-2xl ml-3 object-cover flex-shrink-0"
                />
            </div>
            <div className="flex items-center ml-20">
                <img
                    src={Images.clockIcon}
                    alt="time"
                    className="object-contain w-4 h-4"
                />
                <p className="ml-2 text-base font-medium">
                    {moment(conversation?.created_at).format("LT") === 'Invalid date' ? moment(new Date()).format("LT") : moment(conversation?.created_at).format("LT")}
                </p>
            </div>
        </div>
    )
}
}

export default SupportChatBubble